import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Comment reconnaître une infestation ?",
    desc: "Petits trous ronds (1-3 mm) dans le bois, tas de sciure fine (vermoulure) au pied des poutres, léger cliquetis nocturne (« horloge de la mort »). En saison, présence d'insectes bruns de 3-5 mm autour des fenêtres.",
  },
  {
    title: "Petite ou grosse vrillette ?",
    desc: "La petite vrillette (Anobium punctatum) attaque le bois sec de charpente et meubles. La grosse vrillette (Xestobium rufovillosum) préfère les bois humides et anciens. Traitement différent : nous identifions l'espèce lors du diagnostic.",
  },
  {
    title: "Vrillette ou capricorne des maisons ?",
    desc: "Le capricorne (Hylotrupes bajulus) est bien plus destructeur : galeries ovales, sciure grossière, s'attaque au bois résineux (charpente en pin, sapin). Nous traitons également capricorne, lyctus et termite du bois avec des biocides adaptés.",
  },
  {
    title: "Injection sous pression",
    desc: "Notre méthode principale pour charpentes et poutres structurelles : forage tous les 30 cm, injection de biocide xylophage homologué qui pénètre en profondeur dans le bois via les canaux ligneux. Résultat durable (10 ans).",
  },
  {
    title: "Pulvérisation curative",
    desc: "Pour meubles anciens, parquets, boiseries intérieures : application par pulvérisation ou badigeon d'un insecticide xylophage à effet rémanent. Traitement complet des faces accessibles, séchage rapide.",
  },
  {
    title: "Traitement combiné + garantie 10 ans",
    desc: "Injection + pulvérisation pour les cas sévères, avec bûchage préalable des zones vermoulues (retrait du bois attaqué non structurel). Attestation de traitement et garantie décennale sur la charpente traitée.",
  },
];

const METHOD = [
  { title: "Diagnostic gratuit", desc: "Repérage visuel de la vermoulure, comptage des trous actifs, identification de l'espèce (vrillette petite/grosse, capricorne, lyctus), évaluation de la solidité structurelle." },
  { title: "Devis détaillé", desc: "Devis clair au ml de poutre ou au m² de charpente, avec méthode adaptée. Certibiocide obligatoire. Aucun surcoût caché." },
  { title: "Préparation", desc: "Bâchage du sol, protection des surfaces, dépoussiérage du bois. Bûchage des zones vermoulues non structurelles pour un traitement efficace en profondeur." },
  { title: "Traitement + attestation", desc: "Injection sous pression tous les 30 cm et/ou pulvérisation curative. Ventilation 24 h. Remise d'une attestation de traitement + garantie 10 ans." },
];

const FAQ = [
  {
    q: "Combien coûte un traitement anti-vrillettes en Creuse ?",
    a: "Le tarif dépend du volume de bois à traiter. Compter environ 25-40 €/ml de poutre en injection sous pression, ou 15-25 €/m² pour un traitement de charpente en pulvérisation. Un traitement complet de charpente de maison (100 m²) revient généralement à 1 500-3 000 €. Meuble ancien : à partir de 90 €. Devis gratuit personnalisé après visite.",
  },
  {
    q: "Combien de temps dure le traitement ?",
    a: "Pour un traitement de charpente de maison individuelle : 1 à 2 journées selon la surface. Un meuble ancien : 2-4 heures. La ventilation post-traitement dure 24 h. Vous pouvez réintégrer les lieux dès le lendemain (48 h en cas de traitement intensif).",
  },
  {
    q: "Le traitement est-il vraiment durable ?",
    a: "Oui. Les biocides xylophages que nous utilisons (à base de perméthrine, propiconazole ou tébuconazole) ont une durée d'efficacité de 10 à 15 ans dans le bois traité en injection sous pression, et de 5 à 10 ans en pulvérisation. Nous délivrons une attestation de traitement + garantie décennale pour les charpentes.",
  },
  {
    q: "Comment savoir si l'infestation est active ?",
    a: "Signes d'activité récente : sciure fraîche (blanche/jaune) au pied du bois, apparition de nouveaux trous d'envol au printemps-été, insectes vivants autour des fenêtres, cliquetis audible la nuit. Nous marquons les trous actifs lors du diagnostic pour vérifier après traitement leur disparition.",
  },
  {
    q: "Faut-il quitter la maison pendant le traitement ?",
    a: "Non, dans la plupart des cas. Une éviction de 4-6 h du secteur traité est recommandée pendant l'application et le séchage. Après ventilation, les biocides utilisés sont sans danger pour les occupants. Pour les traitements intensifs de grande surface, nous conseillons de dormir ailleurs la première nuit par précaution.",
  },
  {
    q: "Traitez-vous les meubles anciens et les objets d'art ?",
    a: "Oui. Nous adaptons notre méthode aux meubles précieux : injection localisée aux trous d'envol avec seringue, badigeon ou trempage selon la valeur. Nous prenons toutes les précautions pour ne pas altérer les vernis, patines et finitions anciennes. Devis spécifique pour antiquités.",
  },
  {
    q: "Intervenez-vous dans toute la Creuse ?",
    a: "Oui. Basés à La Celle-Dunoise (23), nous intervenons dans toute la Creuse (Guéret, Aubusson, La Souterraine, Bourganeuf, Boussac, Felletin…) sans surcoût de déplacement, ainsi que dans les départements limitrophes (Haute-Vienne 87, Indre 36, Allier 03).",
  },
  {
    q: "Puis-je bénéficier d'aides ou d'un crédit d'impôt ?",
    a: "Le traitement anti-xylophages n'est pas éligible au crédit d'impôt entretien jardin. En revanche, si le traitement s'inscrit dans une rénovation énergétique globale (avec isolation de combles par exemple), certaines aides ANAH ou MaPrimeRénov' peuvent couvrir une partie. Nous vous conseillons lors du devis.",
  },
];

const CITIES = ["Guéret", "La Souterraine", "Aubusson", "Bourganeuf", "Boussac", "La Celle-Dunoise", "Felletin", "Bénévent-l'Abbaye", "Dun-le-Palestel", "Sainte-Feyre"];

const JSONLD_EXTRA = {
  "@type": "Product",
  name: "Traitement vrillettes du bois et charpente",
  description:
    "Traitement curatif professionnel contre vrillettes, capricornes des maisons, lyctus et autres insectes xylophages. Injection sous pression et pulvérisation biocide homologuée, garantie 10 ans.",
  brand: { "@type": "Brand", name: "K'REUSE EXTÉRIEUR" },
  offers: {
    "@type": "AggregateOffer",
    priceCurrency: "EUR",
    lowPrice: "90",
    highPrice: "3000",
    offerCount: "50",
    availability: "https://schema.org/InStock",
    areaServed: { "@type": "AdministrativeArea", name: "Creuse (23)" },
  },
};

export default function TraitementVrillettesBoisCreuse() {
  return (
    <PestPillarLayout
      slug="traitement-vrillettes-bois-creuse"
      seoTitle="Traitement vrillettes bois Creuse (23) | K'REUSE EXTÉRIEUR"
      seoDescription="Traitement curatif vrillettes, capricornes, xylophages en Creuse. Injection, pulvérisation biocide. Garantie 10 ans. Certibiocide. Devis gratuit."
      breadcrumbLabel="Vrillettes du bois Creuse"
      heroBadge="Traitement xylophages · Garantie 10 ans"
      heroTitleHtml={`Traitement <span class="font-medium text-[#1B5E20]">vrillettes du bois</span> en Creuse (23)`}
      heroSubtitle="Charpentes, poutres, parquets, meubles anciens : nous éliminons vrillettes, capricornes et insectes xylophages avec des biocides homologués Certibiocide. Injection sous pression, garantie 10 ans."
      hero_h2="Sauvez votre charpente avant qu'il ne soit trop tard"
      introParagraphs={[
        "Les vrillettes et autres insectes xylophages (capricorne des maisons, lyctus, termite) détruisent silencieusement les structures en bois. En quelques années, une charpente attaquée peut perdre 30 à 50 % de sa résistance mécanique. La bonne nouvelle : un traitement curatif professionnel stoppe l'infestation en une seule intervention.",
        "K'REUSE EXTÉRIEUR intervient dans toute la Creuse pour traiter vos charpentes, poutres apparentes, parquets, escaliers et meubles anciens. Nous privilégions l'injection sous pression pour les éléments structurels (biocide xylophage injecté tous les 30 cm dans le bois) et la pulvérisation curative pour les surfaces accessibles.",
        "Nos techniciens sont certifiés Certibiocide (agrément d'État obligatoire pour manipuler les biocides à titre professionnel). Nous délivrons une attestation de traitement et une garantie décennale sur les charpentes traitées, précieuse en cas de revente immobilière. Devis gratuit sous 24h après visite.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={CITIES}
      faq={FAQ}
      ctaTitle="Trous et sciure dans vos poutres ? Agissons vite."
      whatsappText="Bonjour, je pense avoir des vrillettes dans ma charpente/mes meubles. Merci de me rappeler pour un diagnostic."
      jsonLdExtra={JSONLD_EXTRA}
    />
  );
}
